module.exports = __webpack_public_path__ + "static/img/140.faf287e.png";